// extracted by mini-css-extract-plugin
export default {"expanderRoot":"Collection_expanderRoot__2CFz_","expander":"Collection_expander__AdtwW","listItem":"Collection_listItem__LYg5g"};